// extracted by mini-css-extract-plugin
export default {"norms__selector":"Norms_norms__selector__ohB2R","norms__spacer":"Norms_norms__spacer__2wkF9","norms__searchResult":"Norms_norms__searchResult__bne70"};